import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaUsers, FaLayerGroup } from 'react-icons/fa';
import Loader from '../../components/Loader';


const PANEL_STYLE = {
  borderRadius: '12px',
  border: '1px solid var(--card-bc)',
  backgroundColor: 'var(--card-bg)',
  overflow: 'hidden',
};

const PANEL_HEADER_STYLE = {
  padding: '12px 16px',
  borderBottom: '1px solid var(--card-bc)',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontWeight: 600,
  fontSize: '0.8rem',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  opacity: 0.7,
};

const PLACEHOLDER_BODY_STYLE = {
  padding: '24px 16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  color: 'var(--bs-secondary)',
  fontSize: '0.875rem',
  opacity: 0.6,
  minHeight: '80px',
};


export default function AdminRoleManagementScreen() {
  const { userInfo } = useSelector((state) => state.auth);

  if (!userInfo) return <Loader />;

  return (
    <>
      {/* ── Page header ──────────────────────────────────────── */}
      <div style={{ marginTop: '32px', marginBottom: '20px' }}>
        <Link
          to={`/admin/home`}
          className='btn btn-light'
          style={{ marginBottom: '16px' }}
        >
          Return to Admin Home
        </Link>
        <h1 style={{ marginBottom: '4px' }}>Role Management</h1>
        <p className='text-muted' style={{ fontSize: '0.9rem', margin: 0 }}>
          Assign roles and groups to admin users. Roles carry permissions; groups are organizational tags.
        </p>
      </div>

      {/* ── 3-panel layout ───────────────────────────────────── */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1.6fr',
          gridTemplateRows: 'auto auto',
          gap: '16px',
          alignItems: 'start',
          marginBottom: '40px',
        }}
      >

        {/* ── LEFT: Admin Users list (full height, spans both rows) ── */}
        <div
          className='shadow-sm'
          style={{
            ...PANEL_STYLE,
            gridRow: '1 / 3',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100vh - 220px)',
          }}
        >
          <div style={PANEL_HEADER_STYLE}>
            <FaUsers size={13} />
            Admin Users
          </div>

          {/* Scrollable body */}
          <div style={{ overflowY: 'auto', flex: 1 }}>
            <div style={PLACEHOLDER_BODY_STYLE}>
              <FaUsers size={28} />
              <span>Admin users list coming in Phase 3</span>
            </div>
          </div>
        </div>

        {/* ── UPPER RIGHT: Roles assignment ── */}
        <div
          className='shadow-sm'
          style={{
            ...PANEL_STYLE,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(50vh - 120px)',
            minHeight: '180px',
          }}
        >
          <div style={PANEL_HEADER_STYLE}>
            <FaShieldAlt size={13} />
            Roles — select a user to assign roles
          </div>
          <div style={{ overflowY: 'auto', flex: 1 }}>
            <div style={PLACEHOLDER_BODY_STYLE}>
              <FaShieldAlt size={28} />
              <span>Role assignment coming in Phase 2 &amp; 3</span>
              <span style={{ fontSize: '0.8rem' }}>
                Roles define permissions for admin users
              </span>
            </div>
          </div>
        </div>

        {/* ── LOWER RIGHT: Groups assignment ── */}
        <div
          className='shadow-sm'
          style={{
            ...PANEL_STYLE,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(50vh - 120px)',
            minHeight: '180px',
          }}
        >
          <div style={PANEL_HEADER_STYLE}>
            <FaLayerGroup size={13} />
            Groups — select a user to assign groups
          </div>
          <div style={{ overflowY: 'auto', flex: 1 }}>
            <div style={PLACEHOLDER_BODY_STYLE}>
              <FaLayerGroup size={28} />
              <span>Group assignment coming in Phase 2 &amp; 3</span>
              <span style={{ fontSize: '0.8rem' }}>
                Groups are organizational tags referenceable in the action log
              </span>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
